import { Component, Inject, ViewChild } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTable } from "@angular/material/table";
import { Select, Store } from "@ngxs/store";
import { SaveEvaluations, Evaluation, EvaluationStateModel,  EvaluationCriteria, Provider } from 'huddyapi';
import { Observable, Subscription } from "rxjs";



@Component({
  selector: 'edit-evaluation-dialog',
  templateUrl: 'edit-evaluation-dialog.component.html',
  styleUrls: ["./edit-evaluation-dialog.component.scss"]
})
export class EditEvaluationDialog  {
  @ViewChild(MatTable) criteriaTable!: MatTable<EvaluationCriteria>;
  evaluations : Evaluation[];
  provider : Provider;
  tempCriteriaId : number = -1;
  saveCriterionAction : string = 'Add';
  criteriaColumns : string[] = ['attribute', 'value',  'remove'];
  evaluation : Evaluation;
  editedCriteria : EvaluationCriteria;
  criteria : EvaluationCriteria[] = [];
  showEditCriterion : boolean = false;
  evaluationForm = this.formBuilder.group({
    providerKey : ['UNDEFINED', [Validators.required]],
    evaluationAmt: ['6', [Validators.required]],
    evaluationUnit: ['months', [Validators.required]],
    windowWeeks: ['2', [Validators.required]],
    perPatientFlag: [false, [Validators.required]],
    attributeName : [],
    attributeValue : [],
    minValue : [],
    maxValue : []
});

  constructor(
    public dialogRef: MatDialogRef<EditEvaluationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    public store : Store
  )
  {
    console.log('Entering edit evaluations', this.data);
    this.evaluations = [].concat(this.data.evaluations);
    if ( this.data.index > -1) {
      this.evaluation = this.evaluations[this.data.index];
      this.evaluationForm.setValue({
        providerKey : this.evaluation.providerKey,
        evaluationAmt: this.evaluation.evaluationAmt,
        evaluationUnit : this.evaluation.evaluationUnit,
        windowWeeks : this.evaluation.windowWeeks,
        perPatientFlag : this.evaluation.perPatientFlag == 1,
        attributeName : '',
        attributeValue : '',
        minValue : '',
        maxValue : ''
      });
    } else {
      this.evaluation = {
        id : undefined,
        providerKey : 'UNDEFINED',
        evaluationAmt: 6,
        evaluationUnit : 'months',
        windowWeeks : 2,
        perPatientFlag : 0,
        providerId : this.data.providerId
      }
    }

  
  
  }

  changeSort($event) {

  }

  ngOnInit() {
    this.criteria = [];
    if (this.evaluation.criteria && this.evaluation.criteria.length > 0) {
      this.criteria = this.criteria.concat(this.evaluation.criteria);
    }
  }

  removeCriterion(criteria : EvaluationCriteria) {
    const idx : number = this.criteria.findIndex(c => c.id == criteria.id);
    if (idx > -1) {
      this.criteria.splice(idx, 1);
      this.criteriaTable.renderRows();
    }
  }

  saveCriterion() {

    this.editedCriteria.value =  this.evaluationForm.value.attributeValue;
    this.editedCriteria.attribute =  this.evaluationForm.value.attributeName;
    this.editedCriteria.minValue =  this.evaluationForm.value.minValue;
    this.editedCriteria.maxValue =  this.evaluationForm.value.maxValue;
    if (!this.editedCriteria.id) {
      this.editedCriteria.id = this.tempCriteriaId--;
      this.criteria.push(this.editedCriteria);
    }
    this.showEditCriterion = false;
    this.criteriaTable.renderRows();


  }

  isValidCriterion() : boolean {
    const attributeName : string = this.evaluationForm.value.attributeName;
    
    const attributeValue : string = this.evaluationForm.value.attributeValue;
    const minValue : number =  this.evaluationForm.value.minValue;
    const maxValue : number = this.evaluationForm.value.maxValue;
    return (attributeName && attributeName != null && attributeName.length > 1) && (
      (attributeValue && attributeValue != null && attributeValue.length > 1) || 
      (minValue && maxValue && minValue < maxValue)
    );
  }

  editCriterion(criterion : EvaluationCriteria | undefined ) {
    this.evaluationForm.controls['attributeName'].reset();
    this.evaluationForm.controls['attributeValue'].reset();
    this.evaluationForm.controls['minValue'].reset();
    this.evaluationForm.controls['maxValue'].reset();
    if (criterion) {
      this.editedCriteria = criterion;
      this.saveCriterionAction = "Update";
      this.evaluationForm.controls['attributeName'].setValue(criterion.attribute);
      this.evaluationForm.controls['attributeValue'].setValue(criterion.value);
      this.evaluationForm.controls['minValue'].setValue(criterion.minValue);
      this.evaluationForm.controls['maxValue'].setValue(criterion.maxValue);
    } else {
      this.editedCriteria = {
          attribute : '',
      };
      this.saveCriterionAction = "Add";
    }

    this.showEditCriterion = true;
  }

  onChangeAttribute() {
    this.evaluationForm.controls['attributeValue'].reset();
    this.evaluationForm.controls['minValue'].reset();
    this.evaluationForm.controls['maxValue'].reset();
  }

  getSupportedAttributeNames() {
    if (this.evaluationForm.value.perPatientFlag == 0) {
      return ['Family Size'];
    } 
    return ['Gender', 'Age Range', 'Family Relationship', 'Not Family Relationship'];
  }

  isNumericValue() {
    const attributeName = this.evaluationForm.value.attributeName;
    return attributeName == 'Family Size' || attributeName == 'Age Range';
  }

  isStringValue() {
    const attributeName = this.evaluationForm.value.attributeName;
    return attributeName == 'Gender' || attributeName == 'Family Relationship' || attributeName == 'Not Family Relationship';
  }

  getDisplayValue(criteria: EvaluationCriteria) : string {
    if (criteria.value && criteria.value.length > 0) {
      return criteria.value;
    } else {
      return criteria.minValue + '-' + criteria.maxValue;
    }
  }

  getAttributeValues() {
    const attributeName = this.evaluationForm.value.attributeName;
    if (attributeName == 'Gender') {
      return [ 'FEMALE', 'MALE']
    } else if (attributeName == 'Family Relationship' || attributeName == 'Not Family Relationship'){
      return ['Primary', 'Spouse', 'Child', 'Parent', 'Unrelated_resident', 'Relation', 'Friend'];
    }
    return [];
  }


  isFormInValid() {
    return (this.evaluationForm.invalid);
  }


  onSubmitForm(treatmentForm) {
   this.save();
  }

  save() {
    console.log('save', this.evaluations, this.evaluation, this.data);
    if (!this.isFormInValid()) {
      this.evaluation.providerKey = this.evaluationForm.value.providerKey;
      this.evaluation.evaluationAmt = this.evaluationForm.value.evaluationAmt;
      this.evaluation.evaluationUnit = this.evaluationForm.value.evaluationUnit;
      this.evaluation.windowWeeks = this.evaluationForm.value.windowWeeks; 
      this.evaluation.perPatientFlag = this.evaluationForm.value.perPatientFlag ? 1 : 0;
      this.evaluation.criteria = this.criteria;
    }
    if (this.data.index == -1) {
      this.evaluations.push(this.evaluation);
    } else {
      this.evaluations[this.data.index] = this.evaluation;
    }
    this.store.dispatch(new SaveEvaluations(this.evaluations)).subscribe(t => {
      this.close();
  });
  }

  close() {
    this.dialogRef.close();
   }

}